import axios from 'axios'
const RawDataModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    FETCH: (state, payload) => {
      state.data = payload
    }
  },
  actions: {
    async fetch({ commit }, payload) {
      try {
        const response = await axios.get(`portal/rawdata/RAWDATATYPE0000001/${payload}`)
        commit('FETCH', response.data)
      } catch (error) {
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.data
    }
  }
}

export default RawDataModule
